import React, { useEffect, useState } from "react";
import OpacityIcon from "@mui/icons-material/Opacity";

const Humidity1Widget = ({ widget, onValueUpdate }) => {
  const [humidity, setHumidity] = useState(0);
  const [isFlashing, setIsFlashing] = useState(false);

  useEffect(() => {
    if (widget?.items?.$w1) {
      const value = Number(widget.items.$w1.value);
      setHumidity(isNaN(value) ? 0 : value);
      setIsFlashing(true);
      setTimeout(() => setIsFlashing(false), 500);
    }
  }, [widget]);

  return (
    <div
      className="flex items-center justify-center gap-2 w-full border rounded-2xl transition-colors duration-500"
      style={{
        height: "40px",
        borderColor: isFlashing ? "hsl(var(--primary))" : "hsl(var(--border))",
      }}
    >
      <OpacityIcon
        style={{
          fontSize: "1.2rem",
        }}
      />
      <span className="text-[0.925rem] font-medium whitespace-nowrap overflow-hidden text-ellipsis max-w-full">
        {humidity.toFixed(1)} %
      </span>
    </div>
  );
};

export default Humidity1Widget;
